




import Vue from 'vue'
import Book from './Book.vue'

export default Vue.extend({
  components: {
    Book,
  },
})
